import { DownOutlined, IdcardOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import dayjs from 'dayjs';
import { handleKeyAmount } from 'features/events';
import { CouponFormField, CouponFormValues } from 'features/events/components/event-details/show-hide-attributes/coupon/coupon-management/Add-coupon-madal/types';
import { useCreateCouponMaster } from 'features/events/use-cases/create-coupon-master';
import { useGetDropDownCommonCoupon } from 'features/shop-item/use-cases/copounCommonDropDown';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { payFormatDate } from 'utils/payload-date-';

export const AddShopCouponModal = ({ onClose, showAddItemModal, couponEditData }: { onClose: () => void; showAddItemModal: boolean, refetch: () => void, couponEditData: any }) => {

    const formName = 'add-shop-coupon-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<CouponFormValues>();
    const { isLoading, mutate } = useCreateCouponMaster();
    const { data: EventData } =
        useGetDropDownCommonCoupon({ Flag: "Event" });
    const handleClose = () => {
        onClose();
        form.resetFields();
    }
    const { t } = useTranslation();

    const valueType = [
        { value: 1, label: 'Flat' },
        { value: 2, label: 'Percent' },
    ];

    const getInitialValues = {
        [CouponFormField.Id]: undefined,
        [CouponFormField.Title]: undefined,
        [CouponFormField.CouponType]: undefined,
        [CouponFormField.couponCode]: undefined,
        [CouponFormField.ValueType]: undefined,
        [CouponFormField.Value]: undefined,
        [CouponFormField.StartDate]: undefined,
        [CouponFormField.EndDate]: undefined,
        [CouponFormField.EventId]: undefined,
        [CouponFormField.Limit]: undefined,
        [CouponFormField.Prefix]: undefined,
        [CouponFormField.NoOfCoupons]: undefined,
        [CouponFormField.IsActive]: true,
        [CouponFormField.shopCouponEventId]: null,


    };
    useEffect(() => {
        if (couponEditData) {
            const { start_date, end_date, ...rest } = couponEditData;
            form.setFieldsValue({
                ...rest,
                start_date: start_date ? dayjs(start_date).format('MM/DD/YYYY') : null,
                end_date: end_date ? dayjs(end_date).format('MM/DD/YYYY') : null
            });
            form.setFieldValue(CouponFormField.StartDate, start_date ? dayjs(start_date) : null);
            form.setFieldValue(CouponFormField.EndDate, end_date ? dayjs(end_date) : null);

        } else {
            form.resetFields();
        }
    }, [couponEditData, showAddItemModal]);


    const handleUpdate = (formData: CouponFormValues) => {
        formData[CouponFormField.Id] = couponEditData?.id;
        formData[CouponFormField.StartDate] = payFormatDate(formData.start_date);
        formData[CouponFormField.EndDate] = payFormatDate(formData.end_date);
        formData[CouponFormField.IsActive] = true;
        formData[CouponFormField.Flag] = "SHOPITEMS_COUPONS";
        mutate(formData, { onSuccess: hanldeSuccess });
    };

    const hanldeSuccess = () => {
        handleClose();
        // if (!couponEditData?.id) refetch();
    }
    const EventDataValue = [
        { value: null, label: "All" }, // ✅ visible in dropdown
        ...(EventData?.DropDownData || []).map((res: any) => ({
            value: res.Id,
            label: res.Title,
        })),
    ];


    return (
        <>
            <div className='popup'>
                <div className='modal_head'>
                    <h4>{couponEditData ? "Edit Coupon" : "Add Coupon"}</h4>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>

                </div>
                <div className='modal_body' >
                    <Form<CouponFormValues>
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        initialValues={getInitialValues}
                        onFinish={handleUpdate}
                        // requiredMark={'optional'}

                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);
                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                    >
                        <FormSectionsSeparator title={""}>
                            <Form.Item
                                label="Event"
                                name={CouponFormField.shopCouponEventId}
                                preserve={false}
                            >
                                <Select
                                    showSearch
                                    allowClear
                                    placeholder="Please Select Event"
                                    options={EventDataValue}
                                    disabled={couponEditData}
                                    optionFilterProp="label"
                                    dropdownMatchSelectWidth={200}
                                    className="filter"
                                    filterOption={(input, option) =>
                                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Form.Item>
                            <Form.Item<CouponFormField>
                                label={"Coupon Title"}
                                name={CouponFormField.Title}

                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: t('validateMessages.custom.nomsg'),
                                    },
                                ]}
                            >
                                <Input
                                    placeholder={"Title"}
                                    prefix={<UserOutlined className='input-prefix-icon' />}
                                />
                            </Form.Item>



                            <Form.Item<CouponFormField>
                                label={"Prefix"}
                                name={CouponFormField.Prefix}

                                rules={[
                                    {
                                        required: true,
                                        message: t('validateMessages.custom.nomsg'),
                                    },
                                    {
                                        min: 2,
                                        max: 2,
                                        message: 'Prefix must be exactly 2 characters long',
                                    },
                                ]}
                            >
                                <Input
                                    placeholder={"Prefix"}
                                    maxLength={2}
                                    disabled={couponEditData?.id}
                                />
                            </Form.Item>

                            <Row gutter={16}>
                                {/* Example: Number of Coupons */}
                                {!couponEditData &&
                                    <Col span={12}>
                                        <Form.Item
                                            label="No of Coupons"
                                            name="no_of_coupons"
                                        >
                                            <Input placeholder="No of coupons" />
                                        </Form.Item>
                                    </Col>}

                                {/* Example: No of People Used */}
                                <Col span={12}>
                                    <Form.Item
                                        label="No of People Used"
                                        name="limit"
                                    >
                                        <Input placeholder="Limit Usage" />
                                    </Form.Item>
                                </Col>
                                {couponEditData?.id && (
                                    <Col span={12}>
                                        <Form.Item
                                            label="Coupon Code"
                                            name="coupon_code"
                                        >
                                            <Input placeholder="" disabled />
                                        </Form.Item>
                                    </Col>
                                )}

                                <Col span={12}>
                                    <Form.Item
                                        label="Value Type"
                                        name="value_type"
                                        rules={[{ required: true, message: t('validateMessages.custom.nomsg') }]}
                                    >
                                        <Select
                                            options={valueType}
                                            placeholder="Select Value type"
                                            suffixIcon={
                                                <>
                                                    <IdcardOutlined className='prefix-icon' />
                                                    <DownOutlined className='suffix-icon' />
                                                </>
                                            }
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item
                                        label="Value"
                                        name="value"
                                        rules={[{ required: true, message: t('validateMessages.custom.nomsg') }]}
                                    >
                                        <Input placeholder="Value" onKeyDown={handleKeyAmount} />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item
                                        label="Start Date"
                                        name="start_date"
                                        rules={[{ required: true, message: t('validateMessages.custom.nomsg') }]}
                                    >
                                        <DatePicker style={{ width: '100%' }} />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item
                                        label="End Date"
                                        name="end_date"
                                        rules={[{ required: true, message: t('validateMessages.custom.nomsg') }]}
                                    >
                                        <DatePicker style={{ width: '100%' }} />
                                    </Form.Item>
                                </Col>


                            </Row>
                        </FormSectionsSeparator>
                        <div className='form-button'>
                            <Button htmlType='submit' className='btn' type='primary'>Save</Button>
                        </div>
                    </Form>
                </div>
            </div >
        </>
    )
};

